import React from "react";
import styled from "styled-components";

const Svg = styled.svg`
  display: block;
`;

const Caution = ({ width = "100%" }) => {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height="auto"
      viewBox="0 0 130 120"
    >
      <g transform="translate(-0.003 -18.258)">
        <path
          d="M124.4,138.258H5.546a5.509,5.509,0,0,1-4.868-8.126l59.427-109a5.557,5.557,0,0,1,9.736,0c64.444,118.2,60.1,109.618,60.1,111.62A5.52,5.52,0,0,1,124.4,138.258Z"
          transform="translate(0 0)"
          fill="#f2d422"
        />
        <path
          d="M149.779,171.847H49.523a3.021,3.021,0,0,1-2.67-4.457L96.98,75.448a3.049,3.049,0,0,1,5.341,0l50.128,91.943A3.021,3.021,0,0,1,149.779,171.847ZM54.623,165.81h90.055L99.651,83.221Z"
          transform="translate(-34.678 -41.578)"
          fill="#585a60"
        />
        <g transform="translate(60.087 71.368)">
          <path
            d="M243.758,228.708h-3.817a2.881,2.881,0,0,0-2.889,2.872l.723,21.359a2.881,2.881,0,0,0,2.889,2.872h2.372a2.881,2.881,0,0,0,2.89-2.872l.722-21.359A2.881,2.881,0,0,0,243.758,228.708Z"
            transform="translate(-236.948 -228.708)"
            fill="#585a60"
          />
          <ellipse
            cx="4.99"
            cy="4.96"
            rx="4.99"
            ry="4.96"
            transform="translate(0 33.357)"
            fill="#585a60"
          />
        </g>
      </g>
    </Svg>
  );
};

export default Caution;



// WEBPACK FOOTER //
// ./src/components/Icons/Tournaments/Caution.js